import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell } from '@material-ui/core';
import VersionHistoryTable, { BodyTableCell } from '../shared';
import { Label } from 'core/components/label';
import { convertUTCToET } from '../../../policy/dates';

const Header = ({ classes }) => (
  <>
    <TableCell size="small" className={classes.tableHeading}>
      Version
    </TableCell>
    <TableCell className={classes.tableHeading}>Internal Notes</TableCell>
  </>
);

Header.propTypes = {
  classes: PropTypes.object.isRequired
};

export const Body = ({ internalNotes, version, updatedDateTime, username, suppressCommunications, classes }) => {
  const adjustedDate = convertUTCToET(updatedDateTime);

  return (
    <>
      <TableRow className={classes.borderlessRow}>
        <BodyTableCell className={classes.borderlessCell}>{`00${version}`.substr(-3)}</BodyTableCell>
        <BodyTableCell className={classes.borderlessCell}>
          {internalNotes}
          {/* #37246: confirmed without contacting the insured/agent */}
          {suppressCommunications && <Label type="infoSubtitleOrange">Communications suppressed</Label>}
        </BodyTableCell>
      </TableRow>
      <TableRow className={classes.borderlessRow}>
        <BodyTableCell colSpan={3} className={classes.dateRow}>
          {`Created ${adjustedDate} ET by ${username || 'member or automation'}`}
        </BodyTableCell>
      </TableRow>
    </>
  );
};

Body.defaultProps = {
  internalNotes: '',
  suppressCommunications: false
};

Body.propTypes = {
  internalNotes: PropTypes.string,
  suppressCommunications: PropTypes.bool,
  version: PropTypes.number.isRequired,
  updatedDateTime: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  username: PropTypes.string.isRequired
};

const SummaryTable = ({ versions, onPageChange, count, page, state }) => (
  <VersionHistoryTable
    body={Body}
    header={Header}
    versions={versions}
    onPageChange={onPageChange}
    count={count}
    page={page}
    state={state}
  />
);

SummaryTable.propTypes = {
  versions: PropTypes.array.isRequired,
  onPageChange: PropTypes.func,
  count: PropTypes.number,
  page: PropTypes.number,
  state: PropTypes.string.isRequired
};

SummaryTable.defaultProps = {
  onPageChange: undefined,
  count: undefined,
  page: undefined
};

export default SummaryTable;
